import DownloadMedia from "./DownloadMedia"

export default DownloadMedia
